// extracted by mini-css-extract-plugin
module.exports = {"hideIcon":"VerdictFilters_hideIcon__25w9b"};